import React from "react";
import { CheckCircle2, Clock, Loader2, XCircle } from "lucide-react";

const STATUS = {
    ok: { label: "Completata", icon: CheckCircle2, className: "border-emerald-300 bg-emerald-50 text-emerald-800" },
    running: { label: "In corso", icon: Loader2, className: "border-amber-300 bg-amber-50 text-amber-800", spin: true },
    error: { label: "Fallita", icon: XCircle, className: "border-red-300 bg-red-50 text-red-800" },
    pending: { label: "Non avviata", icon: Clock, className: "border-slate-200 bg-slate-50 text-slate-500" },
};

export function InvioPipeline({ phases = [], compact = false }) {
    if (!Array.isArray(phases) || phases.length === 0) {
        return <div className="text-xs text-muted-foreground">Stato pipeline non disponibile.</div>;
    }

    return (
        <section data-testid="invio-pipeline" className={compact ? "mt-3" : "mt-4"}>
            <div className="mb-2 text-xs font-bold uppercase tracking-wide text-orange-900">Pipeline telematica</div>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-5">
                {phases.map((phase, index) => {
                    const state = STATUS[phase.status] || STATUS.pending;
                    const Icon = state.icon;
                    return (
                        <div
                            key={phase.code || index}
                            data-testid={`pipeline-phase-${phase.code || index}`}
                            data-status={phase.status || "pending"}
                            className={`rounded-md border px-3 py-2 ${state.className}`}
                        >
                            <div className="flex items-center gap-2">
                                <Icon size={15} className={state.spin ? "animate-spin" : ""} />
                                <span className="text-[11px] font-bold uppercase">{state.label}</span>
                            </div>
                            <div className="mt-1 text-xs font-semibold text-current">{phase.label || phase.code}</div>
                        </div>
                    );
                })}
            </div>
        </section>
    );
}
